import AdminUpdateDesignationForm from 'components/form/admin/master/designation/AdminUpdateDesignationForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AdminUpdateDesignation extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Designation</h4>
                                <AdminUpdateDesignationForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
